import apiSlice from '../api/api.slice';
import { ISubmitFeedbackRequest, IMyFeedback } from './feedback.d';

const feedbackApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyFeedback: builder.query<IMyFeedback[], void>({
      query: () => ({ url: '/api/v1/feedback/me', method: 'GET' }),
      transformResponse: (response: { feedback: IMyFeedback[] }) =>
        response.feedback,
    }),
    submitFeedback: builder.mutation<void, ISubmitFeedbackRequest>({
      query: (body) => ({
        url: '/api/v1/feedback',
        method: 'POST',
        body,
      }),
    }),
    deleteMyFeedback: builder.mutation<void, string>({
      query: (id) => ({ url: `/api/v1/feedback/${id}`, method: 'DELETE' }),
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['MyFeedback'],
  endpoints: {
    getMyFeedback: { providesTags: ['MyFeedback'] },
    submitFeedback: { invalidatesTags: ['MyFeedback'] },
    deleteMyFeedback: { invalidatesTags: ['MyFeedback'] },
  },
});

export const {
  useGetMyFeedbackQuery,
  useSubmitFeedbackMutation,
  useDeleteMyFeedbackMutation,
} = feedbackApiSlice;
